export default "__VITE_ASSET__$Cqq28pH__"